import { Skeleton, type SkeletonProps } from '@mui/material';
import clsx from 'clsx';
import { memo } from 'react';

const PureSkeleton = memo(({ className, ...rest }: SkeletonProps) => (
    <Skeleton className={clsx('bg-gray-bg-base', className)} {...rest} />
));

export default PureSkeleton;
